import { OrganizationType } from "../entities/access/model/dto";

export type UserRole = 'superadmin' | 'admin' | 'user';

export type AccountStatus = 'active' | 'blocked';

export type OrganizationStatus = 'active' | 'suspended';

export interface AccessUser {
    id: string;
    fullName: string;
    email: string;
    organization: string | null;
    organizationId: string | null;
    role: UserRole;
    status: AccountStatus;
    lastLoginAt: string | null;
    maxScanProductDay: number | null;
    maxScanProductMonth: number | null;
}

export interface AccessOrganizationUser {
    id: string;
    fullName: string;
    email: string;
}

export interface AccessOrganization {
    id: string;
    name: string;
    inn: string | null;
    type: OrganizationType | null;
    address: string | null;
    postalCode: string | null;
    usersCount: number;
    requestsUsed: number;
    requestsLimit: number;
    status?: OrganizationStatus;
    users: AccessOrganizationUser[];
}

export const ROLE_LABEL: Record<UserRole, string> = {
    superadmin: 'Суперадмин',
    admin: 'Админ',
    user: 'Пользователь',
};

export type RoleFilter = UserRole | '';
export type AccountStatusFilter = AccountStatus | '';
export type OrganizationStatusFilter = OrganizationStatus | '';

export type OrganizationFilter = string;

export const NO_ORGANIZATION = 'none';
